import { render, staticRenderFns } from "./SearchIAView.vue?vue&type=template&id=0e381198&scoped=true"
import script from "./SearchIAView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchIAView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SearchIAView.vue?vue&type=style&index=0&id=0e381198&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e381198",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e381198')) {
      api.createRecord('0e381198', component.options)
    } else {
      api.reload('0e381198', component.options)
    }
    module.hot.accept("./SearchIAView.vue?vue&type=template&id=0e381198&scoped=true", function () {
      api.rerender('0e381198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documentSearcher/views/SearchIAView.vue"
export default component.exports